import { render, staticRenderFns } from "./MdResultSummary.vue?vue&type=template&id=6d064d58&scoped=true"
import script from "./MdResultSummary.vue?vue&type=script&lang=js"
export * from "./MdResultSummary.vue?vue&type=script&lang=js"
import style0 from "./MdResultSummary.vue?vue&type=style&index=0&id=6d064d58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d064d58",
  null
  
)

export default component.exports